import {Button, Space} from "antd";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../service-feature/useCases/get-orders/context/customer";
import {GetStoreServicesOrdersApiResponse} from "../../../../../../react-query-hooks/store/services/get-orders/types";
import {CustomerServiceOrderCard} from "../card";
import {CustomerStoreServiceOrderDrawer} from "../drawer/order-info/order-details-drawer";
import {CustomerStoreServiceApproveOrderDrawer} from "../drawer/approve-delivery";
import {CustomerStoreServiceOrderRevisionRequestDrawer} from "../drawer/revision-request";
import {CustomerStoreServiceOrderOpenDisputeDrawer} from "../drawer/open-dispute";
import {CustomerStoreServiceOrderLeaveAReviewDrawer} from "../drawer/review";
import {CustomerCancelStoreServiceOrderDrawer} from "../drawer/cancel-order";

export function CustomerServiceOrderListView() {
  const {
    orders,
    state: {currentPage, activeStoreServiceOrderDrawer, selectedStoreServiceOrderInfo},
    dispatch,
    isPreviousData,
    paginationMeta,
  } = useGetCustomerStoreServicesOrdersContext();

  const showOrderInfoDrawer = (order: GetStoreServicesOrdersApiResponse["orders"][0]) => {
    dispatch({
      type: "set-selected-store-service-order-info",
      payload: {
        productService: order.productService,
        hasBeenReviewed: order.revision_requested,
        order,
      },
    });
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };

  const closeAllOrderDrawers = () => {
    // storeServiceOrderDispatch({
    //   type: "reset-state",
    // });
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: null,
    });
    dispatch({
      type: "set-selected-store-service-order-info",
      payload: null,
    });
  };
  return (
    <>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {/* {orders.map((o) => (
          <CustomerServiceOrderCard
            key={o.id}
            order={o}
            onShowDetails={() => showOrderInfoDrawer(o)}
          />
        ))} */}
        {orders.map((o) => {
          if (o.productService) {
            return (
              <CustomerServiceOrderCard
                key={o.id}
                order={o}
                onShowDetails={() => showOrderInfoDrawer(o)}
              />
            );
          } else {
            return null;
          }
        })}

        <div>
          <Space size={12}>
            <Button
              onClick={() =>
                dispatch({
                  payload: Math.max(currentPage - 1, 1),
                  type: "update-current-page",
                })
              }
              disabled={currentPage === 1}
              size="small"
            >
              Previous
            </Button>
            <Button
              onClick={() => {
                if (!isPreviousData && Number(paginationMeta?.next_page) !== 0) {
                  dispatch({
                    payload: currentPage + 1,
                    type: "update-current-page",
                  });
                }
              }}
              // Disable the Next Page button until we know a next page is available
              disabled={isPreviousData || Number(paginationMeta?.next_page) === 0}
              size="small"
            >
              Next
            </Button>
          </Space>
        </div>
      </Space>
      {selectedStoreServiceOrderInfo && (
        <CustomerStoreServiceOrderDrawer
          onOrderInfoDrawerClose={closeAllOrderDrawers}
          openOrderInfoDrawer={activeStoreServiceOrderDrawer === "order-info"}
          orderDetails={selectedStoreServiceOrderInfo}
        />
      )}

      <CustomerStoreServiceApproveOrderDrawer />
      <CustomerStoreServiceOrderRevisionRequestDrawer />
      <CustomerStoreServiceOrderOpenDisputeDrawer />
      <CustomerCancelStoreServiceOrderDrawer />
      {selectedStoreServiceOrderInfo && (
        <CustomerStoreServiceOrderLeaveAReviewDrawer
          orderDetails={selectedStoreServiceOrderInfo}
        />
      )}
    </>
  );
}
